define('appkit/adapter/paginate',[ 
  './param'
], function(ParamAdapter) {

  var Adapter = ParamAdapter.extend({

    postprocess: function(data, resp) {
      this.model.set(resp.page);
    }

  });

  return Adapter;
});
